/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BuildUserOpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {BuildUserOpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const buildUserOp = (request: BuildUserOpRequest, options?: CashRequestOptions) => post<BuildUserOpRequest, BuildUserOpResponse>("/2.0/cash/build-user-op", request, {...options, rejectOnError: true })